import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, number, object, optional, pipe, string, toMinValue } from "valibot";

export const Route = createFileRoute("/supporter/$supporterId/team")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+Team")),
  validateSearch: object({
    q: fallback(optional(string(), ""), ""),
    page: fallback(pipe(optional(number(), 1), toMinValue(1)), 1),
    "page-size": fallback(pipe(optional(number(), 100), toMinValue(10)), 100),
    // Sort parameter in format: "field:direction" or "field1:dir,field2:dir" for multi-sort
    // Standard fields: name, email, country
    // Metadata fields: prefixed with "meta." (e.g. "meta.Department")
    sort: fallback(optional(string()), undefined),
    // Visible metadata columns as comma-separated list (e.g. "Department,CostCenter")
    columns: fallback(optional(string()), undefined),
  }),
  beforeLoad: () => ({
    breadcrumb: "Team",
  }),
  head: () => ({ meta: seo({ title: "Staff" }) }),
});
